import React from "react";

const SvgHelpsolid = ({ title, ...props }) => (
  <svg viewBox="0 0 390 390" {...props}>
    {title ? <title>{title}</title> : null}
    <path d="M195 0C87.3 0 0 87.3 0 195s87.3 195 195 195 195-87.3 195-195S302.7 0 195 0zm29.2 316.8h-49.3v-47.6h49.3v47.6zm17.2-111.4c-14.5 10.5-20.6 16.9-20.6 41.2h-44.6c0-32.4 3.4-46.6 34.4-68.5 13.2-9.1 20.9-19.6 20.9-33.4 0-26.3-18.6-33.4-32.7-33.4-30.4 0-34.8 23-36.5 38.8v.3h-47.6c0-58.7 44.2-79 81-79 20.3 0 86.4 5.7 86.4 71.9.2 27.4-14.7 43.6-40.7 62.1z" />
  </svg>
);

export default SvgHelpsolid;
